export const aspergersUrl: string = 'https://www.autismspeaks.org/what-asperger-syndrome';

export default aspergersUrl;
